import * as Sentry from '@sentry/react';
import {
  IMiddleware,
  MiddlewareContext,
  NextFunction,
} from '../middleware-manager';

export class SentryMiddleware implements IMiddleware {
  async onResponse(
    context: MiddlewareContext,
    next: NextFunction,
  ): Promise<void> {
    await next();

    if (context.response && !context.response.ok) {
      const isAuthError = context.response.status === 401;

      Sentry.captureException(context.response.error, {
        extra: {
          url: context.request.url,
          method: context.request.method,
          status: context.response.status,
          requestBody: JSON.stringify(context.request.body),
          responseData: context.response.data,
        },
        tags: {
          type: isAuthError ? 'auth_error' : 'api_error',
          endpoint: context.request.url,
          is_expected: isAuthError ? 'true' : 'false',
        },
        level: isAuthError ? 'info' : 'error',
      });
    }
  }
}
